<script setup lang="ts">
import { ButtonComponent, Card } from '@metapic-apps/shared'
import { ElDialog } from 'element-plus'
import { ref } from 'vue'

import { useAdvertiserApi } from '@/api/advertiser.api'
import { FlexComponent, TypographyComponent } from '@/ui-library'

const { advertiserId } = defineProps<{
  advertiserId: number
}>()

const showModal = ref(false)

const { loading, deactivate } = useAdvertiserApi()

const handleConfirmDeactivate = async () => {
  await deactivate(advertiserId)
  showModal.value = false
}
</script>
<template>
  <Card title="Deactivate account" title-size="small" class="deactivate-account">
    <TypographyComponent variant="body-large">
      When requesting deactivation, we'll check for any outstanding payments to creators and charge your credit card accordingly. Please
      ensure your card is valid. If we can't process the payment, your account won't be deactivated.
    </TypographyComponent>
    <ElDialog v-model="showModal" :destroy-on-close="true" :show-close="false">
      <template #header>
        <TypographyComponent variant="headline-medium">Deactivate</TypographyComponent>
      </template>
      <FlexComponent direction="column" :gap="16">
        <TypographyComponent variant="body-large">Are you sure you want to deactivate your account?</TypographyComponent>
        <TypographyComponent variant="body-large">
          If you would like to reactivate your account later, reach out to
          <a href="mailto:support@metapic.com" class="pink">support@metapic.com</a>
          at any time.
        </TypographyComponent>
      </FlexComponent>
      <template #footer>
        <FlexComponent direction="row" justify="right" :gap="18">
          <ButtonComponent round variant="text" @click="showModal = false">Cancel</ButtonComponent>
          <ButtonComponent round variant="danger" :is-loading="loading" @click="handleConfirmDeactivate">Deactivate now</ButtonComponent>
        </FlexComponent>
      </template>
    </ElDialog>
    <template #footer>
      <ButtonComponent round variant="danger" class="deactivate-account__button" @click="showModal = true">Deactivate</ButtonComponent>
    </template>
  </Card>
</template>
<style scoped lang="scss">
.deactivate-account {
  &__button {
    align-self: flex-start;
  }
}

.pink {
  color: var(--pink-400);
}
</style>
